var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello grid-center"},[_c('h2',{staticClass:"col-12 text-danger"},[_vm._v(_vm._s(_vm.msg_warning))])])}
var staticRenderFns = []

export { render, staticRenderFns }